export function getQueryFromPath(asPath) {
  const qs = new URLSearchParams(asPath);
  return fromPairs(Array.from(qs.entries()).map(cleanQsPair));
}

function fromPairs(pairs) {
  const result = {};
  for (const [key, value] of pairs) {
    result[key] = value;
  }
  return result;
}

function cleanQsPair([key, value]) {
  const questionIdx = key.indexOf('?');
  const nextKey =
    questionIdx >= 0 && questionIdx + 1 < key.length
      ? key.slice(questionIdx + 1)
      : key;
  return [nextKey, value];
}
